import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCoinWon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="coin-won, currency, money"><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.80078 8L9.79578 16.3H10.0058L11.8958 8.8H12.1058L13.9958 16.3H14.2058L16.2008 8" stroke="currentColor" strokeWidth="1.5"/><path d="M6 12H8.5M15.5 12H18" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCoinWon;
